// extracted by mini-css-extract-plugin
export default {"root":"InvestmentWarning_root__3y_O9"};